import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { usersService } from '@/services/http/usersService'
import { DATA_TABLE_ITEMS_PER_PAGE } from '@/utils/constants'

import type { QueryParams } from '@/utils/queryParams'

type Props = {
  query: QueryParams
  enabled?: boolean
}

export const useUsers = ({ query, enabled = true }: Props) => {
  const { page, limit = DATA_TABLE_ITEMS_PER_PAGE, ...rest } = query
  const { toast } = useToast()

  const {
    data,
    isError,
    isLoading,
    refetch: refetchUsers,
  } = useQuery({
    queryKey: [
      'users',
      {
        page,
        limit,
        ...rest,
      },
    ],
    queryFn: () =>
      usersService.getUsers({
        query,
      }),
    enabled,
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar usuários',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      users: data.users,
      total: data.pagination.total,
      pages: data.pagination.pages,
      isLoading,
      refetchUsers,
    }
  }

  return {
    users: [],
    total: 0,
    pages: 0,
    isLoading,
    refetchUsers,
  }
}
